import './_2fa.scss';
import React, { useEffect, useRef, useState } from 'react';
import { Grid, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import qs from 'qs';

import AlertComponent from '../../components/Alert';
import Loader from '../../components/Loaders/Loader';

import { getAccessRoutes } from '../../routers/helpers';
import { getNavbarConfig, getNavbarCounters } from '../../services/endpoints/general';
import { authConfirm } from '../../services/endpoints/auth';
import { delay, getErrorMessage, isUrlEditor, parseUrl } from '../../utils/helper';
import { userAuthSuccess, userLogoutCredentialsAction } from '../../redux/actions/user';
import * as actionTypes from '../../redux/types/header';
import * as actionTypesGeneral from '../../redux/types/general';

const Page2Fa = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const formRef = useRef(null);

  const query = qs.parse(window.location.search.slice(1), {
    delimiter: ';',
  });
  const { isAuth } = useSelector((state) => state.user);

  const [data, setData] = useState({
    init: false,
    error: null,
    isLoading: false,
    success: false,
    code: '',
  });
  const { init, error, isLoading, success, code } = data;

  const fetchNavbarConfig = async () => {
    try {
      const response = await Promise.all([getNavbarConfig(), getNavbarCounters()]);
      const [config, counters] = response;
      const menuWithCounters = config.data?.menu?.map((item) => {
        const finded = counters?.data?.find((c) => c.code === item.code);
        if (finded) {
          return {
            ...item,
            count: finded.count,
          };
        }
        return item;
      });
      dispatch({
        type: actionTypes.GET_NAVBAR_SUCCESS,
        data: config.data,
        menu: menuWithCounters,
      });
      dispatch({
        type: actionTypesGeneral.CHANGE_VIEW_MODE_SUCCESS,
        payload: config.data.dark_mode,
      });

      return config.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setData((prevState) => ({
        ...prevState,
        error: `Navbar: ${errorMessage}`,
      }));
      throw error;
    }
  };

  const onChangeCode = (e) => {
    const value = e.target.value;
    setData((prevState) => ({
      ...prevState,
      code: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setData((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      /**
       * 1 - Проверка кода
       */
      const response = await authConfirm({ code });
      if (response.data?.access_token) {
        const { access_token } = response.data;
        localStorage.setItem('access_token', access_token);
        setData((prevState) => ({
          ...prevState,
          success: true,
        }));

        /**
         * 2 - Запрос Navbar
         * Для списка приватных роутов
         */
        const navbar = await fetchNavbarConfig();
        const firstRoute = navbar?.menu[0];

        /**
         * 3 - Редирект на приватную страницу
         */
        await delay(500);
        await dispatch(userAuthSuccess(response.data));

        const allAccessRoutes = getAccessRoutes();
        const queryRedirect = query?.redirect ? query.redirect.replace(/^(admin)|(\/admin)/gm, '') : null;
        const url = parseUrl(queryRedirect);
        const firstUrl = firstRoute?.url || '/users';
        const findRoute = allAccessRoutes?.find((r) => {
          if (url) { return r.link === url.pathname }
          return false;
        });
        const redirect = query.redirect === '/' || query.redirect === '/2fa' || query.redirect === '/2fa/app' ? firstUrl : findRoute?.link || firstUrl;
        const isEditor = isUrlEditor(query.redirect);
        isEditor ? (window.location.href = '/admin/editor') : history.push({
          pathname: redirect,
          search: url?.query,
          hash: url?.fragment ? `#${url.fragment}` : null,
        });
      } else {
        throw new Error('Access token is empty');
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      // TODO
      // Пока не ввели попытки, удаляем токен и редиректим на login
      dispatch(userLogoutCredentialsAction(errorMessage));
      history.push('/');
    }
  };

  const checkInit = async () => {
    const access_token = localStorage.getItem('access_token');

    /**
     * ✓ - Авторизация
     */
    if (isAuth) {
      history.push({
        pathname: '/',
        search: history.location.search,
      });
    }

    /**
     * X - Авторизация
     * ✓ - 2fa config
     */
    if (window.appConfig?.second_factor && access_token) {
      setData((prevState) => ({
        ...prevState,
        init: true,
      }));
      return;
    }

    history.push({
      pathname: '/',
      search: history.location.search,
    });
  };

  useEffect(() => {
    document.title = 'Enter 6-digit code';
    checkInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!init) {
    return <Loader />;
  }

  return (
    <div className="page-2fa">
      <Grid bsClass="container">
        <form className="page-2fa__form" ref={formRef} onSubmit={onSubmit}>
          {isLoading ? <Loader success={success} /> : null}
          {error ? (
            <AlertComponent text={error} type="danger" />
          ) : (
            <AlertComponent
              text="<p>Your account is protected with two-factor authentication.</p>We’ve sent you an email. Please check your inbox and enter the code below."
              type="info"
            />
          )}
          <FormGroup>
            <ControlLabel htmlFor="code">Enter 6-digit code</ControlLabel>
            <FormControl required value={code} disabled={isLoading} onChange={onChangeCode} type="text" id="code" name="code" />
          </FormGroup>
          <Button block type="submit" bsStyle="primary" disabled={isLoading}>
            <span>Continue</span>
          </Button>
        </form>
      </Grid>
    </div>
  );
};

export default Page2Fa;
